// Single source of truth for Alpha ad formats (used by the CST table and the chat request banner).
export const AD_FORMAT_OPTIONS = [
  { value: "", label: "Select Ad Format" },
  { value: "full_page", label: "Full Page Ad" },
  { value: "full_video", label: "Full Video" },
  { value: "half_video", label: "Half Video" },
  { value: "promoted_image_story", label: "Promoter Image Story" },
  { value: "promoted_video_story", label: "Promoter Video Story" },
];

// Options that represent a real selectable format (excludes the placeholder).
export const AD_FORMAT_CHOICES = AD_FORMAT_OPTIONS.filter((o) => o.value);

export const adFormatLabel = (value) =>
  AD_FORMAT_OPTIONS.find((o) => o.value === value)?.label || value || "—";
